import { array, object, string, TypeOf } from 'zod';

import { ModelImage } from './common';

/* --------------------------------- Person --------------------------------- */

export const Person = object({
    id: string(),
    lastName: string(),
    name: string(),
    reference: string(),

    description: string().optional(),
    firstName: string().optional(),
    image: ModelImage.optional(),
});

export type Person = TypeOf<typeof Person>;

/* ------------------------------- AllPersons ------------------------------- */

export const AllPersons = object({
    data: array(Person),
});

export type AllPersons = TypeOf<typeof AllPersons>;

/* ----------------------------- PersonProducts ----------------------------- */

export const PersonProduct = object({
    name: string(),
    products: array(string()),
});
export type PersonProduct = TypeOf<typeof PersonProduct>;

export const PersonProducts = object({
    data: array(PersonProduct),
});
export type PersonProducts = TypeOf<typeof PersonProducts>;
